<div class="row mt-4 mt-lg-0 px-3 px-lg-0 card-fade-in">
    <div class="col-12 d-lg-flex justify-content-lg-around">
        <div class="col-12 col-lg-8 col-xl-9">
            <div class="col-12">
                <!-- Sección Imagenes -->
                <mnf-pi-v2-images [phase]="infoProject?.phase" [imagesCarrusel]="infoProject?.gallery || infoProject?.images || infoProject?.newProject?.sectionImages?.images" [infoProject]="infoProject"></mnf-pi-v2-images>
                <!-- End Sección Imagenes -->
            </div>
            <div class="col-12">
                <!-- Sección Descripción y Amenidades -->
                <mnf-pi-v2-description [phase]="infoProject?.phase" [infoProject]="infoProject"></mnf-pi-v2-description>
                <!-- End Sección Descripción y Amenidades -->
            </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 d-none d-lg-block">
            <div class="col-12">
                <!-- Sección card -->
                <mnf-pi-v2-card [totalPartsUsers]="totalPartsUsers" [phase]="infoProject?.phase" [infoProject]="infoProject"></mnf-pi-v2-card>
                <!-- End Sección card -->
            </div>
        </div>
    </div>
</div>